import { HomeFloorGIcon } from './HomeFloorGIcon';

/**
 * author: GreenTurtwig
 * id B2D19D07-ACC6-462B-BD11-50CC805E104B
 * name home-floor-g
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-g.svg
 * tags
 * - Home Automation 
 */
export const HouseFloorGIcon = HomeFloorGIcon;
export default HouseFloorGIcon